import { render, staticRenderFns } from "./PCDetail.vue?vue&type=template&id=2c99156c&scoped=true"
import script from "./PCDetail.vue?vue&type=script&lang=js"
export * from "./PCDetail.vue?vue&type=script&lang=js"
import style0 from "./PCDetail.vue?vue&type=style&index=0&id=2c99156c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99156c",
  null
  
)

export default component.exports